'use-client';
import * as React from 'react';
import type { VerticalLineProps } from '../VerticalLine';
import type { IVerticalLineProps } from '../../../VerticalLine.types';
import VerticalLine from '../../VerticalLine';
import skinsStyle from './styles/VerticalFadeNotchRightLine.scss';
import { BaseVerticalLine } from './BaseVerticalLine';

const VerticalFadeNotchRightLineSkin: React.FC<VerticalLineProps> = props => (
  <BaseVerticalLine {...props} skinsStyle={skinsStyle} />
);

const VerticalFadeNotchRightLine: React.FC<
  Omit<IVerticalLineProps, 'skin'>
> = props => {
  return <VerticalLine {...props} skin={VerticalFadeNotchRightLineSkin} />;
};

export default VerticalFadeNotchRightLine;
